(function () {
  class MachineScrollDisplayComponent extends HTMLElement {
    constructor() {
      super();
      this.colorOptions = [];
      this.currentColor = null;
      this.scrollScene = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.setupElements();
      this.bindEvents();
      this.selectDefaultColor();
      this.initScrollAnimation();
    }

    setupElements() {
      // Get color option buttons
      this.colorOptions = Array.from(this.querySelectorAll('.machine-scroll-display__color-option'));
    }

    bindEvents() {
      // Color switching
      this.colorOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const color = option.dataset.color;
          this.switchColor(color);
        });
      });
    }

    selectDefaultColor() {
      // Find and select default color
      const defaultOption = this.colorOptions.find((opt) => opt.dataset.default === 'true');
      const firstOption = this.colorOptions[0];

      // Get all available color image sets
      const allColorSets = this.querySelectorAll('.machine-scroll-display__color-images-set');

      // Try to select color in this priority:
      // 1. Default marked color option
      // 2. First color option
      // 3. First available color image set (fallback if no color options exist)
      if (defaultOption) {
        this.switchColor(defaultOption.dataset.color);
      } else if (firstOption) {
        this.switchColor(firstOption.dataset.color);
      } else if (allColorSets.length > 0) {
        // Fallback: if no color options, show first available image set
        const firstColorValue = allColorSets[0].dataset.color;
        this.switchColor(firstColorValue);
      }
    }

    switchColor(colorValue) {
      if (this.currentColor === colorValue) return;

      this.currentColor = colorValue;

      // Update active color option button
      this.colorOptions.forEach((option) => {
        if (option.dataset.color === colorValue) {
          option.classList.add('active');
        } else {
          option.classList.remove('active');
        }
      });

      // Show corresponding xbloom-slider for the selected color
      const heroImageSets = this.querySelectorAll('.machine-scroll-display__color-images-set');

      heroImageSets.forEach((set) => {
        const setColor = set.dataset.color;
        if (setColor === colorValue) {
          set.style.display = 'block';
        } else {
          set.style.display = 'none';
        }
      });
    }

    initScrollAnimation() {
      // Skip scroll animation on mobile devices
      const isMobile = window.innerWidth <= 749;
      if (isMobile) {
        // On mobile, ensure element has normal scale (no animation)
        const targetElement = this.querySelector('.machine-scroll-display__hero-machine');
        if (targetElement && typeof gsap !== 'undefined') {
          gsap.set(targetElement, { scale: 1 });
        }
        return;
      }

      // Wait for ScrollMagic and GSAP to be available
      if (typeof ScrollMagic === 'undefined' || typeof gsap === 'undefined') {
        // Retry after a short delay
        setTimeout(() => this.initScrollAnimation(), 100);
        return;
      }

      // Get or create ScrollMagic Controller
      let controller = window.scrollMagicController;
      if (!controller) {
        controller = new ScrollMagic.Controller();
        window.scrollMagicController = controller;
      }

      // Find trigger and target elements
      const triggerElement = this.querySelector('.features-title-wrapper');
      const targetElement = this.querySelector('.machine-scroll-display__hero-machine');

      if (!triggerElement || !targetElement) {
        return;
      }

      // Clean up existing scene if any
      if (this.scrollScene) {
        this.scrollScene.destroy(true);
        this.scrollScene = null;
      }

      // Set initial scale to 3
      gsap.set(targetElement, { scale: 2.5 });

      // Create GSAP timeline for scale animation
      const timeline = gsap.timeline();
      timeline.to(targetElement, {
        scale: 1,
        ease: 'none',
        duration: .1  // Animation duration in seconds
      });

      // Create ScrollMagic Scene
      // Duration is the scroll distance (in pixels) over which the animation completes
      // Using viewport height as a reasonable default
      const scrollDuration = window.innerHeight * 0.8;

      this.scrollScene = new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 1, // Start when element enters viewport
        duration: scrollDuration
      })
        .setTween(timeline)
        // .addIndicators()
        .addTo(controller);

      // Handle cleanup on component removal
      const observer = new MutationObserver(() => {
        if (!document.body.contains(this)) {
          if (this.scrollScene) {
            this.scrollScene.destroy(true);
            this.scrollScene = null;
          }
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  customElements.define('machine-scroll-display-component', MachineScrollDisplayComponent);

  // Handle back/forward cache
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      document.querySelectorAll('machine-scroll-display-component').forEach((component) => {
        if (component.selectDefaultColor) {
          component.selectDefaultColor();
        }
        // Reinitialize scroll animation after page restore
        if (component.initScrollAnimation) {
          component.initScrollAnimation();
        }
      });
    }
  });
})();
